<template>
    <div class="pphistory">
         <div class="menu">
            <el-form :inline="true" >
               <el-form-item label="选择支线">
                <el-select placeholder="请选择支线" v-model="pipelineId" @change="changePipelineId">
                    <el-option label="耕德电子站点侧支线" value="1"></el-option>
                    <el-option label="顶益400支线" value="2"></el-option>
                    <el-option label="娃哈哈200支线" value="3"></el-option>
                    <el-option label="味全食品支线" value="4"></el-option>
                    <el-option label="耕德电子测点间支线" value="5"></el-option>
                </el-select>
              </el-form-item>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('day')">一天
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('week')">
                一周
              </el-button>
              <el-button plain type="primary" class="menu-btn" @click="presetTime('month')">
                一个月
              </el-button>
              <el-button plain type="primary" class="years menu-btn" @click="presetTime('year')">
                一年
              </el-button>

              <el-form-item label="开始时间">
                <!--日期-->
                <el-date-picker
                  v-model="start_time"
                  type="datetime"
                  class="start_date date-input"
                  placeholder="开始时间">
                </el-date-picker>
              </el-form-item>
      
              <el-form-item label="结束时间">
                <!--日期-->
                <el-date-picker
                  v-model="end_time"
                  type="datetime"
                  class="end_date date-input"
                  placeholder="结束时间">
                </el-date-picker>
              </el-form-item>

              <el-button plain type="primary" class="menu-btn" @click="searchHistory()">
                <span>查询</span>
              </el-button>
            </el-form>
        </div>

        <!--表格-->
        <el-table
        :data="histroyData"
        border
        class="report-table data-table"
        style="width: 100%"
        :max-height="tableHight"
        :header-cell-style="{
            background: 'rgba(78,132,255,1)',
            color: 'white',
            textAlign: 'center',
        }">
            <el-table-column
                prop="id"
                label="ID"
            >
            </el-table-column>
            <el-table-column
                prop="recordTime"
                label="记录时间"
            >
            </el-table-column>
            <el-table-column prop="flowMass">
                <template slot="header">
                    <div>瞬时流量<br>(t/h)</div>
                </template>
            </el-table-column>
            <el-table-column prop="flowHeat">
                <template slot="header">
                    <div>瞬时热量<br>(KJ/h)</div>
                </template>
            </el-table-column>
            <el-table-column prop="velocity">
                <template slot="header">
                    <div>流速<br>(m/s)</div>
                </template>
            </el-table-column>
            <el-table-column prop="overHeat1">
                <template slot="header">
                    <div>测点<br>过热度</div>
                </template>
            </el-table-column>
            <el-table-column prop="overHeat2">
                <template slot="header">
                    <div>站点<br>过热度</div>
                </template>
            </el-table-column>
            <el-table-column prop="hLoss">
                <template slot="header">
                    <div>焓降<br>(kJ/kg)</div>
                </template>
            </el-table-column>
            <el-table-column prop="heatLoss">
                <template slot="header">
                    <div>热损<br>(kJ)</div>
                </template>
            </el-table-column>
            <el-table-column prop="heatLossRate">
                <template slot="header">
                    <div>热损率<br>%</div>
                </template>
            </el-table-column>
            <el-table-column prop="heatLossPerMeter">
                <template slot="header">
                    <div>单位长度热损<br>(w/m)</div>
                </template>
            </el-table-column>
            <el-table-column prop="heatLossPerSquare1">
                <template slot="header">
                    <div>单位面积热损<br>(w/m²)</div>
                </template>
            </el-table-column>
            <el-table-column prop="heatLossPerSquare2">
                <template slot="header">
                    <div>保温层单位面积<br>热损(w/m²)</div>
                </template>
            </el-table-column>
            <el-table-column prop="press1">
                <template slot="header">
                    <div>测点压强<br>(MPa)</div>
                </template>
            </el-table-column>
            <el-table-column prop="press2">
                <template slot="header">
                    <div>站点压强<br>(MPa)</div>
                </template>
            </el-table-column>
            <el-table-column prop="tempe1">
                <template slot="header">
                    <div>测点温度<br>(℃)</div>
                </template>
            </el-table-column>
            <el-table-column prop="tempe2">
                <template slot="header">
                    <div>站点温度<br>(℃)</div>
                </template>
            </el-table-column>
        </el-table>

        <!--分页-->
        <el-pagination v-if="page.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 40,100]"
            :page-size="page.size"
            layout="prev, pager, next, jumper,sizes,total"
            :total="page.total">
        </el-pagination>
    </div>
</template>
<script>
import {getPipelineAnalysis} from "@api/decision"
export default {
    name:"pphistory",
    data(){
        return {
            pipelineId:"1" , // 管道编号
            start_time:"" , // 开始时间
            end_time:"", // 结束时间
            histroyData:[], //历史数据
            tableHight:500, // 表格的高度

            page:{ // 分页参数
                total:0,
                size:10,
                current:1
            },
        }
    },
    mounted(){
        this.$nextTick(()=>{
            // 获取页面高度，并设置table高度
            let windowH=window.innerHeight;
            this.tableHight=windowH-170;
        });

        // 获取当前时间，并格式化
        let now=new Date();
        let nowObj=this.$moment(now);
        this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
        this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");

        // 获取管段历史数据
        this.getPipelineAnalysis(1,10);
    },
    methods:{
        // 获取管段的历史数据
        getPipelineAnalysis(page,size){
            page=page||this.page.current;
            size=size||this.page.size;
            getPipelineAnalysis(this.pipelineId,this.start_time,this.end_time,page,size).then(res=>{
                // 设置数据
                if(res.status&&res.status==200){
                    let resdata=res.content;

                    // 设置数据
                    this.histroyData=resdata.content;

                    // 设置分页
                    let tempPage={};
                    tempPage.current=resdata.number+1;
                    tempPage.size=resdata.size;
                    tempPage.total=resdata.totalElements;
                    this.page=tempPage;
                }
            });
        },
        // 管道切换
        changePipelineId(val){
            this.pipelineId=val;
            this.getPipelineAnalysis(1,10);
        },

        // 查询历史数据
        searchHistory(){
            this.getPipelineAnalysis(1,10);
        },
        // 页码改变
        handleCurrentChange(val){
            this.getPipelineAnalysis(val,"");
        },
        // 分页大小改变
        handleSizeChange(val){
            this.getPipelineAnalysis("",val);
        },
        // 预设事件段
        presetTime(type){
            let now=new Date();
            let nowObj=this.$moment(now);
            this.end_time=nowObj.format("yyyy-MM-DD HH:mm:ss");
            switch(type){
                case "day":
                    this.start_time=nowObj.add(-1,'days').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "week":
                    this.start_time=nowObj.add(-1,'weeks').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "month":
                    this.start_time=nowObj.add(-1,'months').format("yyyy-MM-DD HH:mm:ss");
                    break;
                case "year":
                    this.start_time=nowObj.add(-1,'years').format("yyyy-MM-DD HH:mm:ss");
                    break;
            }
            // 查询数据
            this.getPipelineAnalysis(1,10);
        },
    }
    
}
</script>
<style lang="scss">
.pphistory{
    padding:10px;

    /**菜单栏 */
    .menu{
        button{
            cursor: pointer;
            span{
                cursor: pointer;
            }
        }
        .years{
            margin-right: 10px;
        }
    }



    .el-pagination{
        float:right;
    }
}
</style>